import { useState } from "react";
import { faMegaphone } from "@fortawesome/pro-regular-svg-icons";

import { AutoComplete, AutoCompleteItem } from "@/components/AutoComplete/AutoComplete";

import { Modal } from "@/components";
import { useGetWebhooksQuery } from "@/pages/Private/redux/webhook/webhook.api";

import { useSearch } from "@/utils/useSearch";
import { useBulkAddToWebhookMutation } from "@/pages/Private/redux/list/list.api";

export const useWebhooks = () => {
	const [showWebhookModal, setShowWebhookModal] = useState<boolean>(false);
	const [selectedWebhook, setSelectedWebhook] = useState<AutoCompleteItem | null>();
	const { query: webhookQuery, setSearchValue: setWebhookSearchValue } = useSearch();

	const [bulkAddToWebhook, { isLoading: bulkAddToWebhookIsLoading }] =
		useBulkAddToWebhookMutation();

	const { data, isFetching } = useGetWebhooksQuery({
		page: 1,
		limit: 100,
		searchValue: webhookQuery,
	});

	const renderModal = (
		handleAddToWebhook: () => void,
		selectAll: boolean,
		toggleSelectAll: () => void
	) => {
		return (
			showWebhookModal && (
				<Modal
					handleClose={() => setShowWebhookModal(false)}
					handleSave={async () => {
						await handleAddToWebhook();
						selectAll && toggleSelectAll();
						setShowWebhookModal(false);
					}}
					isLoading={bulkAddToWebhookIsLoading}
					isOpened={showWebhookModal}
					size="md"
					submitButtonText={"Add"}
					title={"Add Person to Webhook"}
				>
					<div className="mb-4 flex flex-row items-center">
						{data ? (
							<AutoComplete
								data={
									data?.data?.map((c) => {
										return { id: c.id, title: c.name } as AutoCompleteItem;
									}) || []
								}
								handleSearch={(value: string) => setWebhookSearchValue(value)}
								handleSelect={(value?: AutoCompleteItem) => setSelectedWebhook(value)}
								icon={faMegaphone}
								isLoading={isFetching}
								label={"Webhook"}
								placeholder={"Search for a Webhook"}
								selectedItem={selectedWebhook?.title || ""}
							/>
						) : (
							""
						)}
					</div>
				</Modal>
			)
		);
	};

	return {
		data,
		isFetching,
		renderModal,
		selectedWebhook,
		setShowWebhookModal,
		bulkAddToWebhook,
	};
};
